const prefix = 'knockout';

export const createKnockout = `${prefix}`;
export const updateKnockout = (knockoutId: string) => `${prefix}/${knockoutId}`;

export const getKnockouts = `${prefix}`;

export const getKnockoutDetail = (knockoutId: string) => `${prefix}/${knockoutId}`;
